/**
 * Helpers for turning API errors into something worth showing a user.
 */

/**
 * Extracts the server's own message from an error thrown by the API layer.
 *
 * API.get/post/put/patch/del throw `HTTP {status}: {statusText} - {body}`, where the
 * body is usually JSON like {"message": "..."}. Showing err.message directly puts that
 * whole string in front of the user, so pull out the server's message when there is
 * one and fall back to a written-for-humans default when there is not.
 *
 * @param {Error} err Error thrown by the API layer.
 * @param {string} fallback Message to show when nothing better can be extracted.
 * @returns {string}
 */
export function parseApiErrorMessage(err, fallback) {
  const separator = err?.message?.indexOf(' - ');
  // indexOf, not split: a response body containing ' - ' would otherwise be truncated.
  if (separator === undefined || separator === -1) return fallback;

  const body = err.message.slice(separator + 3).trim();
  if (!body) return fallback;

  try {
    return JSON.parse(body).message || fallback;
  } catch {
    return fallback;
  }
}

export default { parseApiErrorMessage };
